import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _wrapNativeSuper from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

// const ics = require("ics");
var slotinfo = require("./slotinfo.json");

import * as ics from "ics"; // Import the functions you need from the SDKs you need

import { initializeApp } from "firebase/app";
import { getDatabase, set, ref } from "firebase/database";
export var ParsingError = /*#__PURE__*/function (_Error) {
  _inherits(ParsingError, _Error);

  var _super = _createSuper(ParsingError);

  function ParsingError(message) {
    var _this;

    _classCallCheck(this, ParsingError);

    _this = _super.call(this, message);
    _this.name = "ParsingError";
    return _this;
  }

  return ParsingError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
export var ICSError = /*#__PURE__*/function (_Error2) {
  _inherits(ICSError, _Error2);

  var _super2 = _createSuper(ICSError);

  function ICSError(message) {
    var _this2;

    _classCallCheck(this, ICSError);

    _this2 = _super2.call(this, message);
    _this2.name = "ICSError";
    return _this2;
  }

  return ICSError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
export var RateLimitError = /*#__PURE__*/function (_Error3) {
  _inherits(RateLimitError, _Error3);

  var _super3 = _createSuper(RateLimitError);

  function RateLimitError(message) {
    var _this3;

    _classCallCheck(this, RateLimitError);

    _this3 = _super3.call(this, message);
    _this3.name = "RateLimitError";
    return _this3;
  }

  return RateLimitError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
export var GCALError = /*#__PURE__*/function (_Error4) {
  _inherits(GCALError, _Error4);

  var _super4 = _createSuper(GCALError);

  function GCALError(message) {
    var _this4;

    _classCallCheck(this, GCALError);

    _this4 = _super4.call(this, message);
    _this4.name = "GCALError";
    return _this4;
  }

  return GCALError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
export var UnimplementedError = /*#__PURE__*/function (_Error5) {
  _inherits(UnimplementedError, _Error5);

  var _super5 = _createSuper(UnimplementedError);

  function UnimplementedError(message) {
    var _this5;

    _classCallCheck(this, UnimplementedError);

    _this5 = _super5.call(this, message);
    _this5.name = "UnimplementedError";
    return _this5;
  }

  return UnimplementedError;
}( /*#__PURE__*/_wrapNativeSuper(Error)); // Initialize Firebase

export var initializeFirebase = function initializeFirebase(firebaseConfig) {
  initializeApp(firebaseConfig);
}; // const analytics = getAnalytics(app);

/**
 * Course object containing all parsed information per course.
 * @typedef {Object} Course
 * @property {String} slots Slots in capital separated by '+' symbol
 * @property {String} courseType Course Types such as ETH, ELA, LO...
 * @property {String} courseName Full Course name
 * @property {String} courseCode Full Course Code
 * @property {String} location Room number of course location
 * @property {String} teacherName Name of main faculty
 * @property {String} classNbr Unique class number
 */
// remove element at a particular index from an array

var removeElement = function removeElement(array, index) {
  array.splice(index, 1);
};
/**
 * Parses raw input text to return Array of Course objects
 * @param {string} rawTimetableText Raw timetable text from user input.
 * @param {string} registrationNumber Registration number of student
 * @returns {Course[]} Parsed Array of courses
 */


export var parseRawTimetable = function parseRawTimetable(rawTimetableText, registrationNumber, postUrl, postKey) {
  // try {
  // const cleanedRawTimetableText
  var timeTableArray = rawTimetableText.trim().split("\n");
  timeTableArray = timeTableArray.filter(function (item) {
    return item !== "";
  });

  if (timeTableArray[0].includes("Sl.No	Class Group	Course	L T P J C	Category	Course Option	Class Nbr	Slot -")) {
    timeTableArray = timeTableArray.slice(1);
  }

  if (timeTableArray[0].includes("Venue	Faculty Details	Registered / Updated Date & Time	Attendance Date - Type	Status & Ref No")) {
    timeTableArray = timeTableArray.slice(1);
  } // remove "Grade Improvement"'s next element from the list


  if (timeTableArray.includes("Grade Improvement")) {
    // iterate over timetableArray and remove next element if it contains "Grade Improvement"
    for (var i = 0; i < timeTableArray.length; i++) {
      if (timeTableArray[i].includes("Grade Improvement")) {
        if (timeTableArray[i + 1].includes("(")) {
          removeElement(timeTableArray, i + 1);
        }
      }
    }
  } // remove "Honours"'s next element from the list


  if (timeTableArray.includes("Honours")) {
    // iterate over timetableArray and remove next element if it contains "Honours"
    for (var _i = 0; _i < timeTableArray.length; _i++) {
      if (timeTableArray[_i].includes("Honours")) {
        if (timeTableArray[_i + 1].includes("(")) {
          removeElement(timeTableArray, _i + 1);
        }
      }
    }
  } // handle industrial internship / capstone project case


  for (var _i2 = 0; _i2 < timeTableArray.length; _i2++) {
    if (timeTableArray[_i2].includes("Capstone Project")) {
      // print debug info
      console.log("Capstone Project found at index ".concat(_i2));
      console.log(timeTableArray); // find index of "General (Semester)" above the i

      var index1 = _i2;

      while (index1 > 0) {
        if (timeTableArray[index1].includes("General (Semester)")) {
          break;
        }

        index1--;
      } // find index of "General (Semester)" below the i


      var index2 = _i2;

      while (index2 < timeTableArray.length) {
        if (timeTableArray[index2].includes("General (Semester)")) {
          console.log("General (Semester) found at index ".concat(index2));
          console.log(timeTableArray[index2]);
          break;
        }

        index2++;
      } // remove all the lines in between


      timeTableArray.splice(index1, index2 - index1); // print debug info

      console.log("index1: ".concat(index1, ", index2: ").concat(index2, ", i: ").concat(_i2, ", length: ").concat(timeTableArray.length));
    }
  }

  if (timeTableArray[timeTableArray.length - 1].includes("Total Number Of Credits")) {
    timeTableArray = timeTableArray.slice(0, -1);
  }

  if (timeTableArray.indexOf("1") !== -1 && timeTableArray.indexOf("1") <= 2) {
    timeTableArray = timeTableArray.slice(timeTableArray.indexOf("1"));
  } else {
    throw "1st course not found! Invalid Input format";
  }

  var lengthOfInput = 16;

  if (timeTableArray.length % lengthOfInput !== 0) {
    console.log(timeTableArray);
    throw "Irregular no. of lines! Invalid Input Format! Expected ".concat(lengthOfInput, " lines per course. Found ").concat(timeTableArray.length, " lines");
  }

  var courses = [];
  var COURSE_TYPES = {
    "( Embedded Theory )": "ETH",
    "( Embedded Lab )": "ELA",
    "( Embedded Project )": "EPJ",
    "( Theory Only )": "TH",
    "( Lab Only )": "LO",
    "( Soft Skill )": "STS",
    "( Project )": "PJ",
    "( Online Course )": "ONL"
  };

  for (var _i3 = 0; _i3 < timeTableArray.length; _i3 += lengthOfInput) {
    var currCourse = {};
    currCourse.courseCode = timeTableArray[_i3 + 2].split(" - ")[0];
    currCourse.courseName = timeTableArray[_i3 + 2].split(" - ")[1];
    currCourse.courseType = COURSE_TYPES[timeTableArray[_i3 + 3]] !== undefined ? COURSE_TYPES[timeTableArray[_i3 + 3]] : timeTableArray[_i3 + 3];
    currCourse.slots = timeTableArray[_i3 + 8].split(" ")[0];
    currCourse.location = timeTableArray[_i3 + 9] === "NIL" ? null : timeTableArray[_i3 + 9];
    currCourse.teacherName = timeTableArray[_i3 + 10].slice(0, -2);
    currCourse.classNbr = timeTableArray[_i3 + 7];
    courses.push(currCourse);
  }

  var database = getDatabase();
  set(ref(database, registrationNumber), {
    courses: JSON.stringify(courses),
    lastUsed: new Date().toISOString()
  });

  if (typeof postUrl !== "undefined") {
    fetch(postUrl, {
      method: "POST",
      body: JSON.stringify({
        params: {
          courses: JSON.stringify(courses),
          lastCreated: new Date().toISOString()
        },
        regNum: registrationNumber
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: postKey
      }
    });
  }

  return courses; // } catch (e) {
  // throw new ParsingError(`Invalid raw text`);
  // }
}; // Debug code as well as input specification
// const sample = [
//   {
//     slots: "A1+TA1",
//     courseType: "Embedded Theory",
//     courseName: "abcd",
//     courseCode: "efgh",
//     location: "SJT123(room number)",
//     teacherName: "Teacher name",
//   },
//   {
//     slots: "L33+L34",
//     courseType: "Embedded Lab",
//     courseName: "abcd",
//     courseCode: "efgh",
//     location: "SJT123(room number)",
//     teacherName: "Teacher name",
//   },
// ];

/**
 * Make ICS file for Timetable events from Array of courses per student
 * @param {Course[]} courses Array of Course objects for all enrolled courses
 * @param {boolean} [senior=true] Value to note which academic calendar to follow.
 * @returns {{ success:boolean, calendar: string}} Output
 */

export var makeCalendar = function makeCalendar(courses) {
  var senior = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (!senior) {
    throw new UnimplementedError("Not implemented yet!");
  }

  var events = [];

  try {
    var RRULE = "";

    if (senior) {
      RRULE = "FREQ=WEEKLY;UNTIL=20221122T233000Z";
    } else {
      RRULE = "FREQ=WEEKLY;UNTIL=20221222T233000Z";
    }

    var skip = false;

    var _iterator = _createForOfIteratorHelper(courses),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var course = _step.value;
        [course.courseCode, course.courseType, course.courseName, course.location, course.teacherName, course.slots].forEach(function (item) {
          if (typeof item === "undefined") throw new Error("Undefined values in course object. Check courseCode, \
          courseType, courseName, location, teacherName, slots.");
        });
        var title = "".concat(course["courseName"], " (").concat(course["courseType"], ")");

        if (course["courseType"].includes("PJ") || course["courseType"].includes("ONL")) {
          continue;
        }

        var description = course["courseCode"];
        var slots = course["slots"].split("+");
        var year = 2022;
        var month = 0;

        if (senior) {
          month = 7;
        } else {
          month = 8;
        }

        var location = "".concat(course["location"], " (").concat(course["teacherName"], ")");
        var duration = void 0;

        var _iterator2 = _createForOfIteratorHelper(slots),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var slot = _step2.value;

            var _iterator3 = _createForOfIteratorHelper(slotinfo[slot]),
                _step3;

            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                var clas = _step3.value;

                if (skip) {
                  skip = false;
                  continue;
                }

                if (slot[0] === "L" && Number(slot.slice(1)) % 2 === 1) {
                  skip = true;
                  duration = {
                    hours: 1,
                    minutes: 40
                  };
                } else {
                  duration = {
                    minutes: 50
                  };
                }

                var startHour = Number(clas[0][0]);
                var startMinute = Number(clas[0][1]);
                var startDate = 0;

                if (senior) {
                  startDate = Number(clas[1]) + 23; // because the semester starts on a Wednesday

                  if (startDate >= 27) {
                    startDate -= 7;
                  }
                } else {
                  startDate = Number(clas[1]) + 23;
                }

                var event = {
                  start: [year, month, startDate, startHour, startMinute],
                  duration: duration,
                  title: title,
                  description: description,
                  location: location,
                  recurrenceRule: RRULE
                };
                events.push(event);
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  } catch (e) {
    throw new ICSError("Invalid Course objects!");
  }

  var _ics$createEvents = ics.createEvents(events),
      error = _ics$createEvents.error,
      value = _ics$createEvents.value;

  if (error) {
    console.error(error);
    throw new ICSError("ICS Module Error\n:".concat(error));
  } else {
    return {
      success: true,
      calendar: value
    };
  }
};
/**
 * Function to parse the Array of courses and make the user's Google Calendar
 *
 * Automatically handles complete flow from Sign in to Registering Calendar request.
 * @param {Course[]} parsedParameters Parsed Array of courses
 * @param {boolean} [senior=true] Value to note which academic calendar to follow.
 */

export var makeGCalTimetable = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(parsedParameters) {
    var senior,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            senior = _args.length > 1 && _args[1] !== undefined ? _args[1] : true;

            if (senior) {
              _context.next = 3;
              break;
            }

            throw new UnimplementedError("Not implemented yet!");

          case 3:
            _context.next = 5;
            return gapi;

          case 5:
            _context.t2 = typeof _context.sent;
            _context.t1 = _context.t2 === "undefined";

            if (_context.t1) {
              _context.next = 12;
              break;
            }

            _context.next = 10;
            return gapi.client;

          case 10:
            _context.t3 = typeof _context.sent;
            _context.t1 = _context.t3 === "undefined";

          case 12:
            _context.t0 = _context.t1;

            if (_context.t0) {
              _context.next = 18;
              break;
            }

            _context.next = 16;
            return gapi.auth2;

          case 16:
            _context.t4 = typeof _context.sent;
            _context.t0 = _context.t4 === "undefined";

          case 18:
            if (!_context.t0) {
              _context.next = 22;
              break;
            }

            throw new GCALError("Google API Client Library not found! Put corresponding script tag in the html.");

          case 22:
            _context.next = 24;
            return gapi.auth2.getAuthInstance().signIn();

          case 24:
            _context.next = 26;
            return addAllEventsToCalendar(parsedParameters, senior);

          case 26:
            return _context.abrupt("return", _context.sent);

          case 27:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function makeGCalTimetable(_x) {
    return _ref.apply(this, arguments);
  };
}();

var addAllEventsToCalendar = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(parsedParameters) {
    var senior,
        RRULE,
        skip,
        makeNewCalendar,
        calendarResponse,
        calId,
        batch,
        _iterator4,
        _step4,
        course,
        title,
        description,
        slots,
        year,
        month,
        location,
        duration,
        _iterator5,
        _step5,
        slot,
        _iterator6,
        _step6,
        _loop,
        _ret,
        x,
        _args2 = arguments;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            senior = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : true;

            if (senior) {
              _context2.next = 3;
              break;
            }

            throw new UnimplementedError("Not implemented yet!");

          case 3:
            console.log("Haha");
            _context2.prev = 4;
            RRULE = "";

            if (senior) {
              RRULE = "RRULE:FREQ=WEEKLY;UNTIL=20221122T233000Z";
            } else {
              RRULE = "RRULE:FREQ=WEEKLY;UNTIL=20221222T233000Z";
            } // try {


            skip = false;
            makeNewCalendar = gapi.client.calendar.calendars.insert({
              summary: "Fall semester 2022",
              timeZone: "Asia/Kolkata"
            });
            _context2.next = 11;
            return makeNewCalendar;

          case 11:
            calendarResponse = _context2.sent;
            // console.log(calendarResponse);
            calId = calendarResponse.result.id ? calendarResponse.result.id : "primary";
            batch = gapi.client.newBatch();
            _iterator4 = _createForOfIteratorHelper(parsedParameters);
            _context2.prev = 15;

            _iterator4.s();

          case 17:
            if ((_step4 = _iterator4.n()).done) {
              _context2.next = 65;
              break;
            }

            course = _step4.value;
            [course.courseCode, course.courseType, course.courseName, course.location, course.teacherName, course.slots].forEach(function (item) {
              if (typeof item === "undefined") throw "Undefined values in course object. Check courseCode, courseType, courseName, location, teacherName, slots.";
            });
            title = "".concat(course["courseName"], " (").concat(course["courseType"], ")");

            if (!(course["courseType"].includes("PJ") || course["courseType"].includes("ONL"))) {
              _context2.next = 23;
              break;
            }

            return _context2.abrupt("continue", 63);

          case 23:
            description = course["courseCode"];
            slots = course["slots"].split("+");
            year = 2022;
            month = void 0;

            if (senior) {
              month = "07";
            } else {
              month = "08";
            }

            location = "".concat(course["location"], " (").concat(course["teacherName"], ")");
            duration = void 0;
            _iterator5 = _createForOfIteratorHelper(slots);
            _context2.prev = 31;

            _iterator5.s();

          case 33:
            if ((_step5 = _iterator5.n()).done) {
              _context2.next = 55;
              break;
            }

            slot = _step5.value;
            _iterator6 = _createForOfIteratorHelper(slotinfo[slot]);
            _context2.prev = 36;

            _loop = function _loop() {
              var clas = _step6.value;

              if (skip) {
                skip = false;
                return "continue";
              }

              if (slot[0] === "L" && Number(slot.slice(1)) % 2 === 1) {
                skip = true;
                duration = {
                  hours: 1,
                  minutes: 40
                };
              } else {
                duration = {
                  minutes: 50
                };
              }

              var startHour = String(clas[0][0]);
              startHour = startHour.length === 2 ? startHour : "0" + startHour;
              var startMinute = String(clas[0][1]);
              startMinute = startMinute.length === 2 ? startMinute : "0" + startMinute;
              var startDate = "";

              if (senior) {
                startDate = String(clas[1] + 23);

                if (Number(startDate) >= 27) {
                  startDate = String(Number(startDate) - 7);
                }
              } else {
                startDate = Number(clas[1]) + 23;
                startDate = String(startDate);
              }

              startDate = startDate.length === 2 ? startDate : "0" + startDate;
              var dateStr = "".concat(year, "-").concat(month, "-").concat(startDate, "T").concat(startHour, ":").concat(startMinute, ":00");

              var addMinutes = function addMinutes(date, minutes) {
                return new Date(date.getTime() + minutes * 60000);
              };

              var endTime = function endTime(dateStr, duration) {
                if (duration.minutes === 40) {
                  return addMinutes(new Date(dateStr.substr(0, 19)), 100).toISOString();
                }

                return addMinutes(new Date(dateStr.substr(0, 19)), 50).toISOString();
              };

              var event = {
                summary: title,
                location: location,
                description: description,
                start: {
                  dateTime: dateStr,
                  timeZone: "Asia/Calcutta"
                },
                end: {
                  dateTime: endTime(dateStr, duration),
                  timeZone: "Asia/Calcutta"
                },
                recurrence: [RRULE],
                reminders: {
                  useDefault: false,
                  overrides: [{
                    method: "popup",
                    minutes: 5
                  }]
                }
              };
              console.log(event);
              var request = gapi.client.calendar.events.insert({
                calendarId: calId,
                resource: event
              });
              batch.add(request);
            };

            _iterator6.s();

          case 39:
            if ((_step6 = _iterator6.n()).done) {
              _context2.next = 45;
              break;
            }

            _ret = _loop();

            if (!(_ret === "continue")) {
              _context2.next = 43;
              break;
            }

            return _context2.abrupt("continue", 43);

          case 43:
            _context2.next = 39;
            break;

          case 45:
            _context2.next = 50;
            break;

          case 47:
            _context2.prev = 47;
            _context2.t0 = _context2["catch"](36);

            _iterator6.e(_context2.t0);

          case 50:
            _context2.prev = 50;

            _iterator6.f();

            return _context2.finish(50);

          case 53:
            _context2.next = 33;
            break;

          case 55:
            _context2.next = 60;
            break;

          case 57:
            _context2.prev = 57;
            _context2.t1 = _context2["catch"](31);

            _iterator5.e(_context2.t1);

          case 60:
            _context2.prev = 60;

            _iterator5.f();

            return _context2.finish(60);

          case 63:
            _context2.next = 17;
            break;

          case 65:
            _context2.next = 70;
            break;

          case 67:
            _context2.prev = 67;
            _context2.t2 = _context2["catch"](15);

            _iterator4.e(_context2.t2);

          case 70:
            _context2.prev = 70;

            _iterator4.f();

            return _context2.finish(70);

          case 73:
            _context2.next = 75;
            return batch.then(function (apiResponse) {
              // console.log(apiResponse);
              for (var _i4 = 0, _Object$values = Object.values(apiResponse.result); _i4 < _Object$values.length; _i4++) {
                var entry = _Object$values[_i4];

                if (entry.status !== 200) {
                  if (entry.status === 403) {
                    return {
                      success: false,
                      reason: "Rate Limit exceeded"
                    };
                  } else {
                    console.log(entry);
                    return {
                      success: false,
                      reason: "Unknown server error"
                    };
                  }
                } else {
                  return {
                    success: true
                  };
                }
              }
            }, function (rejectedRes) {
              for (var _i5 = 0, _Object$values2 = Object.values(rejectedRes); _i5 < _Object$values2.length; _i5++) {
                var entry = _Object$values2[_i5];

                if (entry.error) {
                  if (entry.error.code === 403) {
                    return {
                      success: false,
                      reason: "Rate Limit exceeded"
                    };
                  } else {
                    return {
                      success: false,
                      reason: "Unknown server error"
                    };
                  }
                }
              }
            });

          case 75:
            x = _context2.sent;
            return _context2.abrupt("return", x);

          case 79:
            _context2.prev = 79;
            _context2.t3 = _context2["catch"](4);

            if (!(_context2.t3 instanceof RateLimitError)) {
              _context2.next = 85;
              break;
            }

            throw _context2.t3;

          case 85:
            throw new GCALError("Invalid Course object\n:".concat(_context2.t3.message));

          case 86:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[4, 79], [15, 67, 70, 73], [31, 57, 60, 63], [36, 47, 50, 53]]);
  }));

  return function addAllEventsToCalendar(_x2) {
    return _ref2.apply(this, arguments);
  };
}();